import { ORM, SessionWithModels, ORMCommonState, Model } from 'redux-orm'
import User from 'src/Entities/User/User';
import ActivityTheme from 'src/Entities/ActivityTheme/ActivityTheme';
import ActivityCategory from 'src/Entities/ActivityCategory/ActivityCategory';
import Activity from 'src/Entities/Activity/Activity';
import Search from 'src/Entities/Search/Search';
import PortalLoadingState from 'src/Entities/PortalLoadingState/PortalLoadingState';
import PortalState from 'src/Entities/PortalState/PortalState';


export type ISession<T> = SessionWithModels<ORMCommonState> & { [P in keyof T]: typeof Model };
export interface IORMModels {
    User: typeof User,
    ActivityTheme: typeof ActivityTheme,
    ActivityCategory: typeof ActivityCategory,
    Activity: typeof Activity,
    Search: typeof Search,
    PortalState: typeof PortalState,
    PortalLoadingState: typeof PortalLoadingState
}

// input the id field name of the db objetcs
ActivityTheme.options = () => ({ idAttribute: 'themeId'})
ActivityCategory.options = () => ({ idAttribute: 'categoryId'})
Activity.options = () => ({ idAttribute: 'detailKursusId'})

export const orm = new ORM();
orm.register<IORMModels>(
  User,
  ActivityTheme,
  ActivityCategory,
  Activity,
  Search,
  PortalLoadingState,
  PortalState
);

export const configureAndGetDefaultOrm = () => {
  return orm;
}



// WEBPACK FOOTER //
// ./src/Config/ConfigureOrm.ts